import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useNavigate } from 'react-router-dom';
import './musicscanner.css';
import './holoscanner.css';

function Holoscanner() {
  const [selectedCategory, setSelectedCategory] = useState('hologram1');
  const navigate = useNavigate();

  const hologram1Data = [
    { url: 'https://www.youtube.com/watch?v=qURgFqJuMkk&list=PLfy1L5lv7HsUO31TgyhxBnn6OJFMpadiF&index=1', title: 'Manvantara Diaries Cosmic Talk Show' },
    { url: 'https://www.youtube.com/watch?v=1ouxbBi8_m8&list=PLfy1L5lv7HsUO31TgyhxBnn6OJFMpadiF&index=2', title: 'Sanatan Vishnus Cosmic Call to Seekers (Hindi)' },
    { url: 'https://www.youtube.com/watch?v=Ai4gwmvZCpU&list=PLfy1L5lv7HsUO31TgyhxBnn6OJFMpadiF&index=3', title: 'Sanatan Vishnus Cosmic Call to Seekers (English)' },
    { url: 'https://www.youtube.com/watch?v=sqPB_rVWo68&list=PLfy1L5lv7HsUO31TgyhxBnn6OJFMpadiF&index=4', title: 'The Cosmic Dialogue Vishnu & Kalki’s QnA (Hindi)' },
    { url: 'https://www.youtube.com/watch?v=qSmCwozuhww&list=PLfy1L5lv7HsUO31TgyhxBnn6OJFMpadiF&index=5', title: 'The Cosmic Dialogue Vishnu & Kalki’s QnA (English)' },
  ];

  const hologram2Data = [
    { url: 'https://www.youtube.com/watch?v=yz_jO9GiFLM&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=1', title: 'African Ubuntu philosophy I am because we are (English)' },
    { url: 'https://www.youtube.com/watch?v=1rPfF2NbUB4&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=2', title: 'African Ubuntu philosophy I am because we are (Hindi)' },
    { url: 'https://www.youtube.com/watch?v=eA5EQkgvy7Q&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=3', title: 'Bhakti movements divine love (Hindi)' },
    { url: 'https://www.youtube.com/watch?v=iakOuAfG2Qw&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=4', title: 'Bhakti movements divine love (English)' },
    { url: 'https://www.youtube.com/watch?v=O3t3_ciA53A&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=5', title: 'Buddha to Kalki The Eternal Journey (Hindi)' },
    { url: 'https://www.youtube.com/watch?v=6zv3eydBfcw&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=6', title: 'Buddha to Kalki The Eternal Journey (English)' },
    { url: 'https://www.youtube.com/watch?v=yioeg5Sdw40&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=7', title: 'Buddha’s message of global unity (Hindi)' },
    { url: 'https://www.youtube.com/watch?v=_L14e9dJXrk&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=8', title: 'Buddha’s message of global unity (English)' },
    { url: 'https://www.youtube.com/watch?v=b-UfqVNVcBM&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=9', title: 'Faith in God’s plan Moses (English)' },
    { url: 'https://www.youtube.com/watch?v=MMWeB2OfINc&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=10', title: 'Faith in God’s plan Moses (Hindi)' },
    { url: 'https://www.youtube.com/watch?v=KkZvSKCN02c&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=11', title: 'AIDHARMA: AI Yug Mein Satya Ki Khoj (Hindi)' },
    { url: 'https://www.youtube.com/watch?v=I0bRLicA-nc&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=12', title: 'AIDHARMA: Navigating Truth in AI Times (English)' },
    { url: 'https://www.youtube.com/watch?v=gdUOqxuBAsY&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=13', title: 'Desires vs Wisdom – The Epic Battle! (English)' },
    { url: 'https://www.youtube.com/watch?v=Nsh9toQkgI0&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=14', title: 'Hanuman vs Sun & Krishna’s Curiosity (Hindi)' },
    { url: 'https://www.youtube.com/watch?v=OCDpg8WHlVc&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=15', title: 'Hanuman vs Sun & Krishnas Curiosity (English)' },
    { url: 'https://www.youtube.com/watch?v=OX5EWADjyWg&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=16', title: 'Lord Kalkis Epic Battle for Education (Hindi)' },
    { url: 'https://www.youtube.com/watch?v=fACNLVD_Ges&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=17', title: 'Lord Kalkis Epic Battle for Education (English)' },
    { url: 'https://www.youtube.com/watch?v=_cql7SWVGAc&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=18', title: 'Shivaji’s Secret Intelligence Network  (Hindi)' },
    { url: 'https://www.youtube.com/watch?v=uxQiLL_vrNg&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=19', title: 'Shivaji’s Secret Intelligence Network  (English)' },
    { url: 'https://www.youtube.com/watch?v=FSdkGs5u5dk&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=20', title: 'STEM Competitions Unleash Your Inner  (Hindi)' },
    { url: 'https://www.youtube.com/watch?v=jTJ76aT-Nj8&list=PLfy1L5lv7HsVBhU-fQAJo4l_qMDohYyqh&index=21', title: 'STEM Competitions Unleash Your Inner  (English)' },
  ];

  const displayData = selectedCategory === 'hologram1' ? hologram1Data : hologram2Data;

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>🌌 Hologram QR Codes</h2>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '30px' }}>
        <button onClick={() => setSelectedCategory('hologram1')} className="qr-button">
          Hologram 1
        </button>
        <button onClick={() => setSelectedCategory('hologram2')} className="qr-button">
          Hologram 2
        </button>
      </div>

      {/* Scrollable QR Section */}
      <div className="qr-scroll-container">
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
          {displayData.map((item, index) => (
            <div key={index} className="qr-item" style={{ textAlign: 'center' }}>
              <QRCodeSVG value={item.url} size={128} />
              <p className="qr-title">QR {index + 1}</p>
              <p className="qr-subtitle">{item.title}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Go Back Button */}
      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <button
          onClick={() => navigate('/admincommon')}
          className="qr-button"
          style={{ padding: '10px 25px', fontSize: '16px' }}
        >
          ⬅️ Go Back to Admin Panel
        </button>
      </div>
    </div>
  );
}

export default Holoscanner;
